import React, { memo } from 'react'
import BouncedIcon from 'transfix-icons/build/BouncedIcon'
import { formatRelativeTime } from 'transfix-ui/components/RelativeDateTime/utils'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IShipmentBouncedCarrierFragment } from '../../graphql/ShipmentBouncedCarrierFragment'

export interface ICarrierOptionBouncedCardProps {
  bouncedAt: IShipmentBouncedCarrierFragment['bouncedAt']
}

const useCarrierOptionBouncedCardStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: brandColors.error0,
    padding: theme.spacing(1.5),
    gap: theme.spacing(1),
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}))

const CarrierOptionBouncedCard = memo<ICarrierOptionBouncedCardProps>(({ bouncedAt }) => {
  const classes = useCarrierOptionBouncedCardStyles()
  const bouncedAtFormattedTime = formatRelativeTime({ datetime: bouncedAt || '' })
  return (
    <div className={classes.root}>
      <div className={classes.icons}>
        <BouncedIcon size='xlarge' color='error1' />
      </div>
      <Typography variant='subtitle1' component='div'>
        This carrier was bounced from the shipment {bouncedAtFormattedTime} ago
      </Typography>
    </div>
  )
})

export default CarrierOptionBouncedCard
